<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Upload {{ filing.year }}'s Missing Paper Filing
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div
            v-if="uploadCompleted"
            class="column is-12  has-text-centered"
          >
            <div class="section">
              <h2 class="title is-4">
                File upload completed successfully
                <span class="icon has-text-info">
                  <i class="fad fa-check-circle" />
                </span>
              </h2>
              <button
                id="modal-back-btn"
                type="button"
                class="button is-secondary"
                @click="$emit('close')"
              >
                Go back to User Statements
              </button>
            </div>
          </div>
          <div
            v-else
            class="column is-12"
          >
            <form>
              <div class="columns">
                <div class="column">
                  <div class="message is-info">
                    <div class="message-body">
                      Use this section to upload old filings that were filed by paper but are currently not present in this system.
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="filing.cityForm === 'Y'"
                class="columns is-vcentered"
              >
                <div class="column">
                  <template v-if="filing.cityUrl !== null">
                    <div class="message is-warning">
                      <div class="message-body">
                        <b>Warning: </b> A <b>City</b> file has already been upload. Uploading a new file will override the existing one. Only upload a new file if the existing file is incorrect.
                      </div>
                    </div>
                  </template>
                  <div class="field">
                    <div class="file has-name is-fullwidth">
                      <label class="file-label">
                        <input
                          id="cityFile"
                          class="file-input"
                          type="file"
                          accept="application/pdf"
                          @change="updateFileState('cityFile', $event)"
                        >
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fas fa-upload" />
                          </span>
                          <span class="file-label">
                            Choose a PDF
                          </span>
                        </span>
                        <span class="file-name">
                          {{ cityFileName !== '' ? cityFileName : 'City statment' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="filing.stateForm === 'Y'"
                class="columns is-vcentered"
              >
                <div class="column">
                  <template v-if="filing.stateUrl !== null">
                    <div class="message is-warning">
                      <div class="message-body">
                        <b>Warning: </b> A <b>State</b> file has already been upload. Uploading a new file will override the existing one. Only upload a new file if the existing file is incorrect.
                      </div>
                    </div>
                  </template>
                  <div class="field">
                    <div class="file has-name is-fullwidth">
                      <label class="file-label">
                        <input
                          id="stateFile"
                          class="file-input"
                          type="file"
                          accept="application/pdf"
                          @change="updateFileState('stateFile', $event)"
                        >
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fas fa-upload" />
                          </span>
                          <span class="file-label">
                            Choose a PDF
                          </span>
                        </span>
                        <span class="file-name">
                          {{ stateFileName !== '' ? stateFileName : 'State statment' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="filing.mayorForm === 'Y'"
                class="columns is-vcentered"
              >
                <div class="column">
                  <template v-if="filing.mayorUrl !== null">
                    <div class="message is-warning">
                      <div class="message-body">
                        <b>Warning: </b> A <b>Mayor</b> file has already been upload. Uploading a new file will override the existing one. Only upload a new file if the existing file is incorrect.
                      </div>
                    </div>
                  </template>
                  <div class="field">
                    <div class="file has-name is-fullwidth">
                      <label class="file-label">
                        <input
                          id="mayorFile"
                          class="file-input"
                          type="file"
                          accept="application/pdf"
                          @change="updateFileState('mayorFile', $event)"
                        >
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fas fa-upload" />
                          </span>
                          <span class="file-label">
                            Choose a PDF
                          </span>
                        </span>
                        <span class="file-name">
                          {{ mayorFileName !== '' ? mayorFileName : 'Mayor statment' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column has-text-centered">
                  <button
                    id="modal-upload-btn"
                    type="button"
                    class="button is-primary"
                    :class="isSaving ? 'is-loading' : ''"
                    :disabled="isSaving"
                    @click.prevent="validateAndUpload"
                  >
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'UploadPaperStatements',
  props: {
    filing: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      cityFileName: '',
      stateFileName: '',
      mayorFileName: '',
      uploadCompleted: false,
      isSaving: false,
      cityFile: null,
      stateFile: null,
      mayorFile: null,
    };
  },
  methods: {
    updateFileState (target, event) {
      if (event.target.files.length) {
        Vue.set(this, target, event.target.files[0]);
        this[`${target}Name`] = event.target.files[0].name;
      }
    },
    async validateAndUpload() {

      this.isSaving = true;

      let hasUpload = 0;
      let formData = new FormData();

      formData.append('filingId', this.filing.id);
      formData.append('year', this.filing.year);

      if (this.cityFile){
        formData.append('cityFile', this.cityFile);
        hasUpload++;
      }

      if(this.stateFile) {
        formData.append('stateFile', this.stateFile);
        hasUpload++;
      }

      if(this.mayorFile) {
        formData.append('mayorFile', this.mayorFile);
        hasUpload++;
      }

      if (hasUpload === 0) {
        this.isSaving = false;
        this.$warning("You must select at least one file to be uploaded.");
        return;
      }

      this.$store.dispatch('filing/uploadHistoricalFiling', formData).then(() => {
        this.uploadCompleted = true;
        this.isSaving = false;
        this.$store.dispatch('filings/fetchUserFilings', this.$store.state.user.tempId);
      });

    },
  },
};
</script>
<style lang="scss" scoped>
  .file-name {
    font-style: italic;
  }
</style>
